import React from "react";
import {useAuth0} from "@auth0/auth0-react";
import {ExitToApp, PersonAdd} from '@mui/icons-material';
import {ListItem, ListItemIcon, ListItemText} from '@mui/material'

function Login() {
    const { loginWithRedirect,logout,isAuthenticated} = useAuth0();
    if(isAuthenticated){
        return(
            <ListItem button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
                <ListItemIcon><ExitToApp/></ListItemIcon>
                <ListItemText>LogOut</ListItemText>
            </ListItem>
        )
    }

    return(
        <ListItem button onClick={()=>{

            loginWithRedirect().then((c)=>console.log(c))
        }
        } >
            <ListItemIcon><PersonAdd/></ListItemIcon>
            <ListItemText>LogIn</ListItemText>
        </ListItem>
    )

}

export default Login;
